import { v4 } from "uuid";

export const genUUID = () => v4().replace(/-/g, "");
